// extracted by mini-css-extract-plugin
module.exports = {"content":"ModalConfirm_content_2jP2w","footer":"ModalConfirm_footer_1APr9"};